import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc); // extends the global dayjs instance — required for .utc() calls below

export enum PaymentInstructionAgeOption {
  MY_AGE = 'MY_AGE',
  SPOUSE_AGE = 'SPOUSE_AGE',
}

export type PaymentInstructionAgeSelection = PaymentInstructionAgeOption | '';

export const decidePaymentInstructionAgeSelection = (
  savedDateOfBirth: string | undefined | null,
  spouseDateOfBirth: string | undefined | null,
): PaymentInstructionAgeSelection => {
  if (!savedDateOfBirth) return '';

  // If account holder and spouse share the same DOB, SPOUSE_AGE wins; this matches
  // legacy behavior and is acceptable because this edge case is extremely rare.
  if (
    spouseDateOfBirth &&
    dayjs.utc(spouseDateOfBirth).format('YYYY-MM-DD') ===
      dayjs.utc(savedDateOfBirth).format('YYYY-MM-DD')
  ) {
    return PaymentInstructionAgeOption.SPOUSE_AGE;
  }

  return PaymentInstructionAgeOption.MY_AGE;
};

export const getPaymentInstructionDateOfBirth = (
  age: PaymentInstructionAgeSelection,
  userDateOfBirth: string | undefined | null,
  spouseDateOfBirth: string | undefined | null,
): string => {
  if (age === PaymentInstructionAgeOption.MY_AGE) return userDateOfBirth ?? '';
  if (age === PaymentInstructionAgeOption.SPOUSE_AGE) {
    return spouseDateOfBirth ?? '';
  }
  return '';
};
